import { render } from "./practice-people-solicitors.html?vue&type=template&id=1cd8737c&scoped=true&ts=true&external"
import script from "./practice-people-solicitors.ts?vue&type=script&lang=ts&external"
export * from "./practice-people-solicitors.ts?vue&type=script&lang=ts&external"

import "./practice-people-solicitors.scss?vue&type=style&index=0&id=1cd8737c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd8737c"]])

export default __exports__